import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import ToastPage from '../../includes/ToastPage';
import '../../../assets/styles/RM.css'
import { useGSecContext } from '../../../services/contexts/assetManagement/GSecContext';
import ListGSecPage from './ListGSecPage';
import CreateGSecPage from './CreateGSecPage';
import DeletedGSecPage from './DeletedGSecPage';


export default function GSecMainPage() {

    const { GSecList, getAllGSecList, showDeletedGSec } = useGSecContext()
    const { setCurrModule, allowedFunc } = useLogin()

    const history = useHistory()

    useEffect(() => {
        (async () => {
            try {
                if (allowedFunc.includes(configs.functionList['gsec_management:view_asset_data'])) {
                    setCurrModule(configs.modules.gsecMgmt)
                    getAllGSecList()
                } else {
                    return history.goBack()
                }
            } catch (error) {

            }
        })()
    }, [])

    // role management main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                {showDeletedGSec ? <div id='rmContainer' className="rm-container"><DeletedGSecPage /></div> :
                    <div id='rmContainer' className="rm-container">
                        <ListGSecPage />
                        {allowedFunc.includes(configs.functionList['gsec_management:create_asset']) || allowedFunc.includes(configs.functionList['gsec_management:update_asset']) ?
                            <CreateGSecPage />
                            : null}
                        <ToastPage />
                    </div>
                }
            </div>
        </>
    )
}